import { z } from "zod";

// GET …/apartments/{apartmentId}?rooms=true. Only the room fields room notes need.
export const coreApartmentRoomsSchema = z.object({
    data: z.object({
        rooms: z.array(z.object({
            id: z.number(),
            ifcguid: z.string().nullable().optional(),
            comment: z.string().nullable().optional()
        })).optional()
    })
});
